import React from 'react';
import PropTypes from 'prop-types';
import HoverTooltip from '@Components/HoverTooltip';
import { Dropdown } from '@els/els-react--dropdown';
import { optionShape } from '../Shared/FlyoutContent';

function OperatorsDropdown({ options, selected, onChange }) {
  const handleOptionChange = (option) => {
    onChange(option);
  };

  return (
    <HoverTooltip theme="simple" tooltip="Boolean operators" tooltipPlace="bottom">
      <Dropdown id="operators-dropdown" label={selected.label} options={options} onChange={handleOptionChange} />
    </HoverTooltip>
  );
}

OperatorsDropdown.propTypes = {
  options: PropTypes.arrayOf(optionShape).isRequired,
  selected: optionShape.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default OperatorsDropdown;
